import TuneRoundedIcon from "@mui/icons-material/TuneRounded";

export const tune = (props) => {
  return <TuneRoundedIcon {...props} />;
};
